export const encodeStoryTitle = (title) => encodeURIComponent(title);
export const decodeStoryTitle = (title) => decodeURIComponent(title);
